import {DaneKlienta} from '../../../services/samoobsluga/types/dane-klienta';

export const daneKlientaStanPoczatkowy: DaneKlienta = {
  imie: '',
  nazwisko: '',
  telefon: '',
  email: '',
  czyPosiadaNumerKonta: false,
  czyMaMozliwoscPozniejszegoWyliczenia: true
}
